import { Label } from "@/components/ui/label";
import { SearchableSelect } from "@/components/ui/searchable-select";

export function OrderProductField({ form, manufacturedItems, value, onSelect }) {
  const showCustom = form.product_name && (!form.bom_item_id || form.bom_item_id === "none");
  const options = [
    ...(showCustom ? [{ value: "__custom__", label: `${form.product_name} (custom)`, sku: "__custom__" }] : []),
    ...manufacturedItems.map((b) => ({ value: b.id, label: `${b.name} (${b.sku})`, keywords: `${b.name} ${b.sku}`, sku: b.sku })),
  ];
  return (
    <div className="space-y-1.5">
      <Label>Product</Label>
      <SearchableSelect
        value={value}
        onValueChange={onSelect}
        options={options}
        placeholder="Select a product"
        searchPlaceholder="Search products…"
        emptyText="No manufactured BOM products yet — add one on the BOM tab."
        testid="order-form-product-name"
        optionTestid={(o) => `order-form-product-opt-${o.sku}`}
      />
      <p className="text-[11px] text-slate-400">Choose a manufactured product from your BOM — its recipe links automatically for material planning.</p>
    </div>
  );
}
